import { isTabletDevice } from '@va/dashboard/selectors/ui';
import { PageContent, PageHeaderItemsWrapper } from '@va/dashboard/shared/ui-layout';
import { NavAddCircle } from '@va/icons';
import { useTranslate } from '@va/localization';
import { MAX_APPLIED_SUMO_VOUCHERS } from '@va/standalone/shared/constants';
import { isUserLoggedInWithCustomUrl } from '@va/standalone/shared/helpers';
import { getApiRequest, getVouchersList, isAgencyOwner, isSumoUser } from '@va/standalone/shared/selectors';
import { SeeMoreArrow } from '@va/svg-visa-icons';
import { RefreshButton } from '@va/ui/components/buttons';
import { Button } from '@va/ui/design-system';
import { useRefreshContext } from '@va/util/components';
import { Link } from '@va/util/router';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { RemoveWebsiteContextProvider } from '../RemoveWebsiteV2/removeWebsiteContext';
import { ManageWebsitesReportBlock } from './ManageWebsitesRb';

const ManageWebsitesPage = () => {
  const translate = useTranslate();
  const sumoAccountType = useSelector(isSumoUser);
  const vouchers = useSelector(getVouchersList);
  const { manualRefresh } = useRefreshContext();

  const isTablet = useSelector(isTabletDevice);
  const vouchersInfo = useSelector((state) => getApiRequest(state, 'getVouchersInfo'))?.toJS() ?? {};
  const agencyOwner = useSelector(isAgencyOwner);
  const history = useHistory();

  const hasWebsiteCreatePermission = useMemo(
    () => !isUserLoggedInWithCustomUrl() || (isUserLoggedInWithCustomUrl() && agencyOwner),
    [agencyOwner],
  );

  return (
    <RemoveWebsiteContextProvider>
      <PageHeaderItemsWrapper>
        <RefreshButton refreshFn={manualRefresh} />
        {hasWebsiteCreatePermission && (
          <Button
            onClick={() => {
              history.push('/my-account/add-website');
            }}
            text={isTablet ? undefined : translate('button.addNewWebsite')}
            icon={(_, color) => <NavAddCircle color={color} />}
          />
        )}
      </PageHeaderItemsWrapper>

      <PageContent>
        {sumoAccountType && vouchers.size > 0 && vouchersInfo?.vouchers && (
          <div className='mt-10'>
            <SumoVouchersInfoHeader vouchers={vouchers} vouchersInfo={vouchersInfo} />
          </div>
        )}
        <ManageWebsitesReportBlock />
      </PageContent>
    </RemoveWebsiteContextProvider>
  );
};

export default ManageWebsitesPage;

/**
 *
 * TODO- Will fix the type for Vouchers
 */
const SumoVouchersInfoHeader = ({
  vouchers,
  vouchersInfo,
}: {
  vouchers: any;
  vouchersInfo: { vouchers: number; visitsLimit: number; maxUsage: number; applied: number };
}) => {
  const translate = useTranslate();

  return (
    <div className='appsumo-websites-info'>
      {translate(vouchers.size === 1 ? 'appsumo.websitesInfo.singleCode' : 'appsumo.websitesInfo.multipleCodes', {
        codes: vouchersInfo?.vouchers ?? 0,
        visits: vouchersInfo?.visitsLimit ?? 0,
        totalWebsites: vouchersInfo?.maxUsage ?? 0,
        websites: vouchersInfo?.applied ?? 0,
      })}
      {vouchers.size < MAX_APPLIED_SUMO_VOUCHERS ? (
        <span>&nbsp;{translate('appsumo.websitesInfo.addMoreVouchers')}</span>
      ) : null}

      <Link to={'/appsumo'}>
        <SeeMoreArrow className={'icon see-more-icon'} />
      </Link>
    </div>
  );
};
